/* this file is auto-generated.  DO NOT MODIFY*/
import BasicForm from '../../src/js/modules/BasicForm.js';
import ConsultantDetail from '../../src/js/modules/ConsultantDetail.js';
import HandlebarsTemplate from '../../src/js/modules/HandlebarsTemplate.js';
import InstrumentItemList from '../../src/js/modules/InstrumentItemList.js';
import InstrumentReportDetail from '../../src/js/modules/InstrumentReportDetail.js';
import ItemDetail from '../../src/js/modules/ItemDetail.js';
import ParticipantUpload from '../../src/js/modules/ParticipantUpload.js';
import ProjectGroupView from '../../src/js/modules/ProjectGroupView.js';
import ProjectSessionEmailModal from '../../src/js/modules/ProjectSessionEmailModal.js';
import ProjectSessionsList from '../../src/js/modules/ProjectSessionsList.js';
import QuickView from '../../src/js/modules/QuickView.js';
import Singleton from '../../src/js/modules/Singleton.js';
import Transient from '../../src/js/modules/Transient.js';
import VisualizationDetail from '../../src/js/modules/VisualizationDetail.js';

export default [
		BasicForm,
		ConsultantDetail,
		HandlebarsTemplate,
		InstrumentItemList,
		InstrumentReportDetail,
		ItemDetail,
		ParticipantUpload,
		ProjectGroupView,
		ProjectSessionEmailModal,
		ProjectSessionsList,
		QuickView,
		Singleton,
		Transient,
		VisualizationDetail
	];

